import { RootState } from '@state/types';
import { UndoEntry } from './types';

const newest = (state: RootState) => state.undo.history[state.undo.history.length - 1];

// The change Cmd+Z and the calendar's Undo button take back next.
export const getEntry = (state: RootState) => newest(state)?.entry ?? null;

// What it was, for the button's tooltip.
export const getMessage = (state: RootState) => newest(state)?.message ?? null;

export const getSeq = (state: RootState) => state.undo.seq;

// Older changes fell off the end, past the limit.
export const getDropped = (state: RootState) => state.undo.dropped;

export const getStep = (state: RootState, entry: UndoEntry) => state.undo.history.find(step => step.entry === entry);

export const getLastUndone = (state: RootState) => state.undo.lastUndone;
